module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Skip Item',
        mainHeader: 'Are you sure you would like to skip your next order? Your subscription will automatically resume shipment on',
        skip: 'Skip',
        cancel: 'Cancel',
        item: 'ITEM',
        qty: 'Qty',
        notRated: 'Not rated',
        oneReview: '1 review',
        yearlySavings: 'yearly savings',
        nextShipmentBy: 'Next Shipment by'
    };

    return resources[label];
};
